import React, { useEffect } from "react";
import { Toast } from "ratel-ui";
import { Router, Route } from "react-router";
import { createBrowserHistory } from "history";
import { ThemeProvider } from "styled-components";
import lightTheme from "./themes/light";
import "ratel-ui/index.css";
import Zoing from "./enemSimulation/containers/details";
import Gabarito from "./enemSimulation/containers/gabarito";
import Lives from "./landing";
import LandingCraquesEnem from "./modules/craques_enem/pages/landing";
import SimulationList from "./modules/Simulation/pages/list";
import AltaHospitalarForm from "./modules/altaHospitalar/pages/AltaHospitalarForm";
import AltaHospitalarPreview from "./modules/altaHospitalar/pages/AltaHospitalarPreview";
import SosSimuladosPage from "./modules/sos_2026/pages/SimuladosPage";
import SosSimuladoPage from "./modules/sos_2026/pages/SimuladoPage";
import SosLoginPage from "./modules/sos_2026/pages/LoginPage";
import SosGabaritoPage from "./modules/sos_2026/pages/GabaritoPage";
import SosTransmissaoPage from "./modules/sos_2026/pages/TransmissaoPage";
import LandingSos from "./modules/sos_lp/LandingSos";

const history = createBrowserHistory();

export default function Root() {

  // useEffect(() => {
  //   window.location.href = "https://aprovatotal.com.br/sos-aprova-2024"
  // }, []);

  return (
    <ThemeProvider theme={lightTheme}>
      <Router history={history}>
        {/* SOS Aprova 2026 */}
        <Route exact path="/simulados" component={SosSimuladosPage} />
        <Route exact path="/simulados/:area" component={SosSimuladoPage} />
        <Route exact path="/login" component={SosLoginPage} />
        <Route exact path="/gabarito" component={SosGabaritoPage} />
        <Route exact path="/ao-vivo" component={SosTransmissaoPage} />

        {/* Craques do Enem */}
        <Route exact path="/simulado" component={LandingCraquesEnem} />
        <Route exact path="/simulado/:slug" component={Zoing} />
        <Route exact path="/craques-enem/gabarito" component={Gabarito} />
        <Route exact path="/gerar-alta-hospitalar/:day" component={AltaHospitalarForm} />
        <Route exact path="/gerar-alta-hospitalar/preview/:day" component={AltaHospitalarPreview} />
        <Route exact path="/craques-enem" component={LandingCraquesEnem} />
        <Route exact path="/" component={LandingSos} />
      </Router>
      <Toast.box />
    </ThemeProvider>
  );
}
